import {mianApiGet,mianApiPost} from './http';
// 案例地址
export const apiUserlogin = data => mianApiPost('/login/login.html', data);// 登录接口
export const apiSendcode = data => mianApiPost('/login/sendcode.html', data);// 短信接口
export const apiSavepwd = data => mianApiPost('/login/savepwd.html', data);// 修改密码
export const apiSaveinvoiceinfo = data => mianApiPost('/crmdata/saveinvoiceinfo.html', data);// 修改密码
export const apiAliyunSts = data => mianApiPost('/user/aliyunsts.html', data);// 获取阿里云OSS的STS临时权限
export const apiSaveheadportrait = data => mianApiPost('/crmdata/saveheadportrait.html', data);// 修改头像
export const apiArticlelists = data => mianApiPost('/article/lists.html', data);// 文章列表
export const apiArticleinfo = data => mianApiPost('/article/info.html', data);// 文章详情
export const apiGoodsnav = data => mianApiPost('/goods/nav.html', data);// 产品分类
export const apiGoodslists = data => mianApiPost('/goods/lists.html', data);// 产品列表
export const apiDealercollectenter = data => mianApiPost('/dealercollect/entercollect.html', data);// 收藏操作
export const apiOrderinfolists = data => mianApiPost('/orderinfo/lists.html', data);// 我的订单

export const apiGoodsgrouplists = data => mianApiPost('/groupgoods/lists.html', data);// 组合
export const apiGoodsinfo = data => mianApiPost('/goods/info.html', data);// 商品详情
export const apiGroupgoodsinfo = data => mianApiPost('/groupgoods/info.html', data);// 组合详情
export const apiOrderinfo = data => mianApiPost('/orderinfo/info.html', data);// 订单详情
export const apiBillsinfo = data => mianApiPost('/orderinfo/billsinfo.html', data);// 订单详情
export const apiOrderdetailinfo = data => mianApiPost('/orderinfo/detailinfo.html', data);// 订单详情
export const apiWarehousebillsgoodslists = data => mianApiPost('/warehousebillsgoods/lists.html', data);// 订单详情

export const apiMapdata = data => mianApiGet('/static/data/100000_full.json', data);// 国家
export const apiProduct = data => mianApiGet('/static/data/product.json?time=1', data);// 案例
export const apiInvoiceapply = data => mianApiPost('/orderinvoice/apply.html', data);// 申请开票
export const apiInvoicelists = data => mianApiPost('/orderinvoice/lists.html', data);// 票据列表
export const apiInvoiceinfo = data => mianApiPost('/orderinvoice/info.html', data);// 票据详情
export const apiOrdercatalog = data => mianApiPost('/orderinfo/ordercatalog.html', data);// 票据详情
export const apiOrdercatalogstate = data => mianApiPost('/ordercatalog/state.html', data);// 票据详情
export const apiWechatpay = data => mianApiPost('/wechatpay/pagepay.html', data);// 获取微信支付二维码
export const apiPaypalurl = data => mianApiPost('/paypal/pagepay.html', data);// 获取微信支付二维码
export const apiWarehousebillsgoods = data => mianApiPost('/warehousebills/billsgoods.html', data);// 获取微信支付二维码
export const apiWarehousebillsgoodscalculate = data => mianApiPost('/warehousebillsgoods/calculate.html', data);// 获取微信支付二维码
export const apiHomeindex = data => mianApiPost('/home/index.html', data);// 获取微信支付二维码
export const apiCrmdatainfo = data => mianApiPost('/crmdata/info.html', data);// 获取微信支付二维码
export const apiDealeruserlogininfo = data => mianApiPost('/dealeruser/logininfo.html', data);// 登录信息更新


export const apiOrderinfosetcredit = data => mianApiPost('/orderinfo/setcredit.html', data);// 获取微信支付二维码
export const apiHometongji = data => mianApiPost('/home/tongji.html', data);// 获取微信支付二维码



// WEBPACK FOOTER //
// ./src/request/api.js